import { call, put } from 'redux-saga/effects';

import { apiService } from 'evee-ui-common/services';
import { redirectIfError } from 'evee-ui-common/utils';

import * as appActions from 'store/modules/app/actions';
import * as customerActions from 'store/modules/customer/actions';

function* loadAccountInfo(action) {
  const accountId = action.payload;

  try {
    yield put(appActions.setLoading(true));
    const accountInfo = yield call(apiService.customer.getAccountInfo, { accountId });
    yield put(customerActions.loadSuccess(accountInfo));
  } catch (error) {
    yield put(customerActions.loadFailed());
    yield put(appActions.showRequestError());
    redirectIfError(error);
  } finally {
    yield put(appActions.setLoading(false));
  }
}

export { loadAccountInfo };
